import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { PartnerProvidersPage } from '@/features/partner/providers-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/partner/providers/'
)({
  beforeLoad: async () => {
    await requireRoles(['owner', 'admin', 'team_leader', 'finance'])
    await requireActiveSubscription()
  },
  component: PartnerProvidersPage,
})
